module.exports = __webpack_public_path__ + "img/zxsign4.d0edabb8.png";